import React, { FC } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/AppContext';
import { LanguageConstants } from '../../utils/LanguageConstants';

type Props = {
  vale: {
    tipoLista: number;
    numOferta: string;
    fechaIniVigencia: any;
    fechaFinVigencia: string;
    fechaFinCanjeoDTO: string;
    fechaFinActivacion: string;
    fechaFinCanjeoPromo: string;
    visualizar: boolean;
    activable: boolean;
    gupoInternoVisualizar: string;
    grupoInternoActivacion: string;
    valeEAN: string;
    exclusividad: boolean;
    entregada: boolean;
    canjeada: boolean;
    activada: boolean;
    idioma: string;
    textoReclamo: string;
    textoTitulo: string;
    textoDescripcion1: string;
    textoDescripcion2: string;
    canalActivacion: string;
    canales: object;
    fechaActivacion: string;
    tipoVale: string;
    scoring: number;
    codImpacto: number;
    planAdhesion: number;
    denominacionPlanAdhesion: string;
    soportePostal: number;
    denominacionSoportePostal: string;
    valeDestacado: string;
    estructurasComerciales: object;
    tienda: string;
    fechaCanjeo: any;
    horaCanjeo: any;
    locale: string;
    preferencia: string;
    fechaInicioCanjeo: string;
    showValeEntrega: boolean;
    tipoReclamo: string;
    canalesVisualizacion: object;
    showPopup: boolean;
    masivo?: boolean;
  };
};
const ValeComponentActivableCanjeable: FC<Props> = ({ vale }) => {
  const { t, i18n } = useTranslation();
  const idiomaActual = i18n.language;
  const dataApp = useAppStore();
  const formatoFechaCanjeo =
    dataApp.lang === 'eu' ? 'YYYY/MM/DD' : 'DD/MM/YYYY';
  const CUPON_CANJEADO = 3;
  const CUPON_ACTIVADO = 2;
  const CUPON_NO_ACTIVADO = 1;
  const CUPON_MASIVO_NO_ACTIVADO = 5;
  const CUPON_MASIVO_ACTIVADO = 6;
  const CUPON_MASIVO_CANJEADO = 7;
  const estiloDeFecha = () => {
    if (idiomaActual === LanguageConstants.LOCALE_EUSKERA && vale.masivo) {
      return (
        <p>
          <span className="bloque-vale__fecha">{vale.fechaFinActivacion}</span>
          {!vale.masivo
            ? t('vales.activableHasta')
            : t('vales.masivos.no-activados.activableCanjeableHasta')}
        </p>
      );
    }
    return (
      <p>
        {!vale.masivo
          ? t('vales.activableHasta')
          : t('vales.masivos.no-activados.activableCanjeableHasta')}
        <span className="bloque-vale__fecha">{vale.fechaFinActivacion}</span>
      </p>
    );
  };

  if (
    vale.tipoLista === CUPON_NO_ACTIVADO ||
    vale.tipoLista === CUPON_MASIVO_NO_ACTIVADO
  ) {
    return <>{estiloDeFecha()}</>;
  }

  if (
    vale.tipoLista === CUPON_ACTIVADO ||
    vale.tipoLista === CUPON_MASIVO_ACTIVADO
  ) {
    return (
      <>
        <p>
          {!vale.masivo
            ? t('vales.canjeableHasta')
            : t('vales.masivos.activados.activableCanjeableHasta')}
          <span className="bloque-vale__fecha">{vale.fechaFinCanjeoPromo}</span>
        </p>
      </>
    );
  }
  if (
    vale.tipoLista === CUPON_CANJEADO ||
    vale.tipoLista === CUPON_MASIVO_CANJEADO
  ) {
    return (
      <>
        <p>
          {!vale.masivo
            ? t('vales.canjeadoEl')
            : t('vales.masivos.canjeados.activableCanjeableHasta')}
          <span className="bloque-vale__fecha">
            {vale.fechaCanjeo && vale.fechaCanjeo !== ''
              ? moment((vale.fechaCanjeo as unknown) as Date).format(
                  formatoFechaCanjeo,
                )
              : '-'}
          </span>
        </p>
      </>
    );
  }
  return <></>;
};

export default ValeComponentActivableCanjeable;
